import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss']
})
export class InputComponent {
  @Input() clearButton = false;
  @Input() label = '';
  @Input() type:
    | 'button'
    | 'checkbox'
    | 'email'
    | 'password'
    | 'radio'
    | 'text'
    | 'number'
    | 'tel' = 'text';
  @Input() inputMode:
    | 'text'
    | 'decimal'
    | 'numeric'
    | 'tel'
    | 'search'
    | 'email'
    | 'url' = 'text';
  @Input() error: string | null = '';
  @Input() placeholder = '';
  @Input() control!: FormControl;
  @Input() maxLength!: number | null;
  @Input() icon:
    | ''
    | 'email'
    | 'phone'
    | 'company'
    | 'person' = '';
  @Output() clearEvent = new EventEmitter<boolean>();
  @ViewChild('input') public inputRef!: ElementRef;

  handleClearClick(): void {
    this.clearEvent.emit();
  }
}
